import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=14bde5d5&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=14bde5d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bde5d5",
  null
  
)

export default component.exports